module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Agiez-e9dccf203f5a53f67aba5f5132b79b49.svg";